import {useRoot} from '../../Root/hooks';
import {useOpenLink} from '../../Links';

export default () => {
  const {configuration} = useRoot();

  return useOpenLink(configuration.values.appStoreUrl);
};
